import { css } from '@emotion/react';

export interface InputStyles {
	minHeight?: string;
	position?: string;
	display?: string;
	flexDirection?: string;
	height?: string;
	flex?: string;
}

export const useInputStyle = ({ minHeight, position, height, flex, display, flexDirection }: InputStyles = {}) => {
	return css`
		.tiptap {
			line-height: 1.8;
			${minHeight ? `min-height: ${minHeight};` : ''}
			padding: 0.5rem;
			display: ${display ?? 'flex'};
			flex-direction: ${flexDirection ?? 'column'};
			${position ? `position: ${position};` : ''}
			${flex ? `flex: ${flex};` : ''}
			height: ${height ?? '100%'};
		}

		// placeholder text
		.tiptap p.is-editor-empty:first-of-type::before {
			color: var(--chakra-colors-text-softest);
			content: attr(data-placeholder);
			float: left;
			height: 0;
			pointer-events: none;
		}

		.tiptap [data-type='amount'] {
			background-color: var(--chakra-colors-points-bgAlpha);
			border-radius: 100px;
			color: var(--chakra-colors-points-fg);
			padding: 4px 6px;
		}

		.tiptap [data-type='hashtag'] {
			background-color: var(--chakra-colors-hashtag-bgAlpha);
			border-radius: 100px;
			color: var(--chakra-colors-hashtag-fg);
			padding: 4px 6px;
		}

		.tiptap [data-type='mention'] {
			color: var(--chakra-colors-primary-fg);
		}

		.tiptap [data-type='recipient'] {
			background-color: var(--chakra-colors-primary-bgAlpha);
			border-radius: 100px;
			color: var(--chakra-colors-primary-fg);
			padding: 4px 6px;
		}

		.ProseMirror:focus {
			outline: none;
		}
	`;
};
